<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;"><span
                class="text-muted fw-light">Business
                Profile /</span> Company Details</h4>

        <mat-card>
            <mat-card-header class="mt-3">
                <mat-icon>apartment</mat-icon>Company Details
            </mat-card-header>

            <hr class="my-0 mt-3 mb-3" />

            <mat-card-content>
                <form [formGroup]="companyDetailsForm" (ngSubmit)="onSubmit()">
                    <!-- <mat-grid-list rowHeight="350"
                    [cols]="breakpoint"  (window:resize)="onResize($event)">
                        <mat-grid-tile> -->
                    <div class="row">
                        <div class="col-md-6">

                            <div class="adminControls">

                                <mat-form-field appearance="outline">
                                    <mat-label>Company Name</mat-label>
                                    <input matInput formControlName="CompanyName"
                                        [ngClass]="{'is-invalid':submitted && forms.CompanyName.errors}" required>
                                    <mat-error *ngIf="submitted && forms.CompanyName.errors" class="invalid-feedback">
                                        <div *ngIf="forms.CompanyName.errors.required"> This field is required </div>
                                        <div *ngIf="forms.CompanyName.errors.maxlength">Maximum length is 25</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" id="byid">
                                    <mat-label>Company Registration Number</mat-label>
                                    <input matInput formControlName="CompanyRegistrationNumber"
                                        [ngClass]="{'is-invalid':submitted && forms.CompanyRegistrationNumber.errors}"
                                        required readonly="true">
                                    <mat-error *ngIf="submitted && forms.CompanyRegistrationNumber.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.CompanyRegistrationNumber.errors.required"> This field is
                                            required </div>
                                        <div *ngIf="forms.CompanyRegistrationNumber.errors.maxlength">Maximum length is
                                            25</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput formControlName="ZipCode" OnlynumberDirective
                                    (input)="onZipCodeChange($event)"
                                        [ngClass]="{'is-invalid':submitted && forms.ZipCode.errors}" required autocomplete="doNotAutoComplete">
                                    <mat-error *ngIf="submitted && forms.ZipCode.errors" class="invalid-feedback">
                                        <div *ngIf="forms.ZipCode.errors.required"> This field is required </div>
                                        <div *ngIf="forms.ZipCode.errors.minlength">Mininmum length is 5</div>
                                        <div *ngIf="forms.ZipCode.errors.maxlength">Maximum length is 5</div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>State</mat-label>
                                    <!-- <input matInput formControlName="State"> -->
                                      <!--  [ngClass]="{'is-invalid':submitted && forms.State.errors}" required>-->
                                     <mat-select formControlName="State" name="State" id="State" 
                                        [ngClass]="{'is-invalid':submitted && forms.State.errors}" 
                                         required autofocus>
                                        <mat-option *ngFor="let State of states" [value]="State">
                                            {{ State }}
                                        </mat-option>
                                    </mat-select> 
                                    <!-- <mat-error *ngIf="submitted && forms.State.errors" class="invalid-feedback">
                                        <div *ngIf="forms.State.errors.required"> This field is required </div>
                                    </mat-error> -->
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="Country"
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" required>
                                    <mat-error *ngIf="submitted && forms.Country.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Country.errors.required"> This field is required </div>
                                    </mat-error>
                                </mat-form-field> -->
                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>Country</mat-label>
                                    <input matInput formControlName="Country" name="Country" id="Country" required
                                        [ngClass]="{'is-invalid':submitted && forms.Country.errors}" autofocus>
                                    <mat-error *ngIf="submitted && forms.Country.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Country.errors.required">Country is required</div>
                                    </mat-error>
                                </mat-form-field> -->
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Nature of Business</mat-label>
                                    <input matInput formControlName="NatureOfBusiness"
                                        [ngClass]="{'is-invalid':submitted && forms.NatureOfBusiness.errors}" required>
                                    <mat-error *ngIf="submitted && forms.NatureOfBusiness.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="forms.NatureOfBusiness.errors.required"> This field is required
                                            <div *ngIf="forms.NatureOfBusiness.errors.maxlength">Maximum length is 25
                                            </div>
                                        </div>
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline" id="byid">
                                    <mat-label>Tax ID Number</mat-label>
                                    <input matInput formControlName="TaxIdNumber"
                                        [ngClass]="{'is-invalid':submitted && forms.TaxIdNumber.errors}" required
                                        readonly="true">
                                    <mat-error *ngIf="submitted && forms.TaxIdNumber.errors" class="invalid-feedback">
                                        <div *ngIf="forms.TaxIdNumber.errors.required"> This field is required </div>
                                        <div *ngIf="forms.TaxIdNumber.errors.maxlength">Maximum length is 25</div>
                                    </mat-error>
                                </mat-form-field>

                                <!-- <mat-form-field appearance="outline">
                                    <mat-label>District</mat-label>
                                    <input matInput formControlName="District"
                                        [ngClass]="{'is-invalid':submitted && forms.District.errors}" required>
                                    <mat-error *ngIf="submitted && forms.District.errors" class="invalid-feedback">
                                        <div *ngIf="forms.District.errors.required"> This field is required </div>
                                        <div *ngIf="forms.District.errors.maxlength">Maximum length is 25</div>
                                    </mat-error>
                                </mat-form-field> -->

                               
                                <!-- <mat-form-field appearance="outline" style="visibility: hidden;">
                                    <mat-label>Zip Code</mat-label>
                                    <input matInput>
                                </mat-form-field> -->

                                <mat-form-field appearance="outline">
                                    <mat-label>Address</mat-label>
                                    <input matInput formControlName="Address"
                                        [ngClass]="{'is-invalid':submitted && forms.Address.errors}" required>
                                    <mat-error *ngIf="submitted && forms.Address.errors" class="invalid-feedback">
                                        <div *ngIf="forms.Address.errors.required"> This field is required </div>
                                        <div *ngIf="forms.Address.errors.maxlength">Maximum length is 25</div>
                                    </mat-error>
                                </mat-form-field>
                                
                                <mat-form-field appearance="outline">
                                    <mat-label>City </mat-label>
                                    <!-- <input matInput formControlName="City"
                                        [ngClass]="{'is-invalid':submitted && forms.City.errors}"> -->
                                    <mat-select formControlName="City" name="City" id="City" required
                                        [ngClass]="{'is-invalid':submitted && forms.City.errors}">
                                        <mat-option *ngFor="let City of cities" [value]="City">
                                            {{ City }}
                                        </mat-option>
                                    </mat-select>
                                    <!-- <mat-error *ngIf="submitted && forms.City.errors" class="invalid-feedback">
                                        <div *ngIf="forms.City.errors.required"> This field is required </div>
                                        <div *ngIf="text">{{text}}</div>
                                    </mat-error> -->
                                </mat-form-field>

                                
                            </div>
                        </div>
                    </div>
                    <alert></alert>
                    <mat-card-actions>
                        <button type="button" mat-raised-button style="margin-left:40px;" class="button"
                            (click)="onSubmit()" [disabled]="isLoading">
                            <!-- <mat-icon class="icons" *ngIf="status==false">edit </mat-icon> -->
                            <span class="material-symbols-outlined" *ngIf="status==false">
                                edit
                            </span>
                            <mat-icon class="icons" *ngIf="status==true" style="margin-right: 30px;">save</mat-icon>
                            {{status==false ? 'Edit' :'Save Changes' }}
                        </button>
                        <button mat-raised-button *ngIf="status" (click)="reset()" class="buttonReset">
                            Cancel</button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>